import React from 'react';
import { HeaderOrigination } from '@honeycomb-npm/honeycomb-react';
import { content } from '../../../utils/contentUtils';

const Header = () => {
  const { closeBtn } = content.callToAction;
  const handleRedirect = () => {
    window.open('https://www.commbank.com.au/', '_self');
  };
  return (
    <HeaderOrigination
      closeText={closeBtn.displayText}
      hideClose={false}
      logoHref="https://www.commbank.com.au/"
      onClick={handleRedirect}
    />
  );
};

export default Header;
